import { useCallback, useState } from 'react';

function deconstructEvent(event, date) {
  event.persist();
  let value = null;
  if (event.target.type === 'file') {
    const [file] = event.target.files;
    value = file;
  } else if (event.target.type === 'checkbox') {
    value = event.target.checked;
  } else {
    value =
      event.target.type === 'date' || event.target.type === 'time' ? date : event.target.value;
  }
  const id = event.target.type ? event.target.id : event.currentTarget.id;
  return { id, value };
}

// eslint-disable-next-line import/prefer-default-export
export const useForm = (controls, actions, options) => {
  const [errors, setErrors] = useState({});
  if (actions?.controlsChanged == null && options?.onChange == null) {
    throw new Error('Parameters are missing change callback');
  }

  const isValid = useCallback(
    (id, value) =>
      options.validations[id] == null ||
      options.validations[id].every((validation) => validation.check(value)),
    [options],
  );

  const validate = useCallback(
    (id, value) => {
      let isValidAux = true;
      const newErrors = [];

      // eslint-disable-next-line no-restricted-syntax
      for (const validation of options.validations[id]) {
        if (validation.check(value)) {
          // eslint-disable-next-line no-continue
          continue;
        }
        isValidAux = false;
        if (newErrors[id] == null) {
          newErrors[id] = [];
        }
        newErrors.push(validation.message ?? 'Campo inválido');
      }
      setErrors((state) => ({ ...state, [id]: newErrors.length === 0 ? undefined : newErrors }));

      return isValidAux;
    },
    [options.validations],
  );

  const validateAll = useCallback(() => {
    // console.log('useForm');
    const ids = Object.keys(options.validations);
    let isValidAux = true;
    const newErrors = {};

    // eslint-disable-next-line no-restricted-syntax
    for (const id of ids) {
      const value = controls[id];
      // eslint-disable-next-line no-restricted-syntax
      for (const validation of options.validations[id]) {
        if (validation.check(value)) {
          // eslint-disable-next-line no-continue
          continue;
        }
        isValidAux = false;
        if (newErrors[id] == null) {
          newErrors[id] = [];
        }
        newErrors[id].push(validation.message ?? 'Campo inválido');
      }
    }
    setErrors(newErrors);

    return isValidAux;
  }, [options.validations, controls]);

  const onChange = useCallback(
    (event) => {
      const hasControlsChanged = actions && 'controlsChanged' in actions;
      const { id, value } = deconstructEvent(event, null); // TODO: Pass date

      if (id == null) {
        throw new Error('Input is missing id');
      }

      // Either validate on change or clear errors if it is valid
      if (options?.validateOnChange) {
        validate(id, value);
      } else if (isValid(id, value)) {
        setErrors((errs) => ({ ...errs, [id]: undefined }));
      }

      if (hasControlsChanged) {
        actions.controlsChanged({ [id]: value });
      } else {
        options.onChange(id, value);
      }
    },
    [options, actions, isValid, validate],
  );

  const onSubmit = useCallback(
    (callback) => {
      const valid = validateAll();
      if (valid) {
        callback();
      }
    },
    [validateAll],
  );

  const resetErrors = useCallback(() => {
    setErrors({});
  }, [setErrors]);

  return { errors, onChange, onSubmit, resetErrors };
};
